export default {
  apiKey: 'AIzaSyDb5kpkHhR7Ajc3rpsbJZ2ZMNPGguBnGvM',
  authDomain: 'memi-blog.firebaseapp.com',
  databaseURL: 'https://memi-blog.firebaseio.com',
  projectId: 'memi-blog',
  storageBucket: 'memi-blog.appspot.com',
  messagingSenderId: '399471123461',
  appId: '1:399471123461:web:e46e7454e114efaa3e106c',
  measurementId: 'G-82PHZRWMDR'
}
